module.exports = __webpack_public_path__ + "img/circle.1793779a.svg";